import * as React from 'react';
import { Link } from 'react-router-dom';
import { ClassName } from '../../utils/utils';
import { isExternalLink } from '../../helpers/isExternalLink';

interface IFlashMessageProps {
  children: any;
  type?: string;
  visible: boolean;
  onTimeout?: () => void;
  link?: string;
}

class FlashMessage extends React.Component<IFlashMessageProps> {
  
  private timeout: any;

  constructor(props: IFlashMessageProps) {
    super(props);

    this.state = {
      isVisible: this.props.visible
    };

    this.onTimeout = this.onTimeout.bind(this);
  }

  public onTimeout() {
    clearTimeout(this.timeout);
    if (!this.props.onTimeout) {
      return;
    }
    this.props.onTimeout();
  }

  public render() {
    clearTimeout(this.timeout);

    const { children, type, visible, onTimeout, link } = this.props;

    if (visible && onTimeout) {
      this.timeout = setTimeout(() => { this.onTimeout(); }, 5000);
    }

    const className = ClassName('flashMessage', [type]) + (this.props.visible ? ' isVisible' : '');

    if (link) {
      // odkaz jinam
      if (isExternalLink(link)) {
        return (
          <a href={link} className={className} target="_blank">
            {children}
          </a>
        );
      }

      // interní odkaz
      return (
        <Link to={link} className={className} onClick={this.onTimeout}>
          {children}
        </Link>
      );
    }

    // alert bez odkazu
    return (
      <div className={className} onClick={this.onTimeout}>
        {children}
      </div>
    );
  }
}

export default FlashMessage;



// WEBPACK FOOTER //
// ./src/modules/FlashMessage/FlashMessage.tsx